import React from 'react'
import { connect } from 'react-redux'
import { Modal, ErrorBoundary } from 'components'

function Clear(props) {
  const { setActiveGoal, deleteAllGoals } = props
  return (
    <Modal title="Delete all goals?" handleClose={() => props.history.goBack()}>
      <div className="dialog">
        <ErrorBoundary>
          <h4>Are you sure you want to delete all goals from your plan?</h4>
          <div>
            <button
              className="danger"
              onClick={() => {
                props.history.replace('/')
                setActiveGoal(null)
                deleteAllGoals()
              }}
            >
              Delete
            </button>
            <button className="light" onClick={() => props.history.goBack()}>
              Cancel
            </button>
          </div>
        </ErrorBoundary>
      </div>
    </Modal>
  )
}

export default connect(
  null,
  { ...require('store/actions') }
)(Clear)



// WEBPACK FOOTER //
// ./src/components/modals/Clear.js